import { IconStar, IconStarFilled } from "@tabler/icons-react";
import classNames from "classnames";
import s from "../video-conf.module.scss";
import Rating from "react-rating";
import { TextCollapse } from "@shared/ui/text-collapse/text-collapse";
import { CustomVideoPlayer } from "@shared/ui/custom-video-player";
import { Modal } from "@shared/ui/modal/modal";


export const EndedState = ({
  hasRecord,
  appointmentRecord,
  isRecordVisible,
  setIsRecordVisible,
  isTeacher,
	feedback_message,
	feedback_rating,
	openAddReview
}) => (
  <div className={classNames(s.stateCard, s.ended)}>

    {!isTeacher ? (
      <>
        <div className={s.feedbackBlock}>
					<img src={process.env.REACT_APP_STORAGE_URL + "images/draw-icons/rating.png"} alt="" className={s.feedbackImage} />
          {feedback_rating ?
					<>
						<div className={s.feedbackTitle}>Ваш отзыв</div>
						<div className={s.reviewBlock}>
							<Rating className={s.reviewStars} fullSymbol={<IconStarFilled size={18} className={s.star}/>} emptySymbol={<IconStar size={18} className={s.star}/>} readonly={true} initialRating={feedback_rating}/>
							<div className={s.feedbackText}>
								<TextCollapse className={s.reviewText} maxHeight={46.8}>{feedback_message}</TextCollapse>
							</div>
						</div>
					</>
					 : 
					<>
						<div className={s.feedbackTitle}>Как прошло занятие?</div>
						<div className={s.feedbackText}>
							Поделитесь впечатлением, это поможет преподавателю и другим ученикам.
						</div>
					</>}
        </div>
      </>
    ) : <>
        <div className={s.feedbackBlock}>
					<img src={process.env.REACT_APP_STORAGE_URL + "images/draw-icons/rating.png"} alt="" className={s.feedbackImage} />
          <div className={s.feedbackTitle}>Занятие завершено</div>
					<div className={s.feedbackText}>
            {/* Материалы и запись будут доступны еще 30 дней */}
          </div>
        </div>
      </>}
    <div className={s.metaActions}>
			{!isTeacher && !feedback_rating && <button type="button" className={s.connectButton} onClick={openAddReview}>
				Оцените занятие
			</button>}

			<button type="button" className={s.settingsButton} onClick={() => setIsRecordVisible(true)}
        disabled={!hasRecord}>
				Смотреть запись
			</button>
    </div>

    <Modal
      isOpen={isRecordVisible && hasRecord}
      close={() => setIsRecordVisible(false)}
      style={{ content: { padding: 0 } }}
    >
      <div className={classNames(s.recordModal, 'record-modal')}>
        <CustomVideoPlayer
          wrapperClassName={s.recordModalVideoWrapper}
          className={s.video}
          src={appointmentRecord?.url}
          allowPiP={false}
        />
      </div>
    </Modal>

  </div>
);
